import React from 'react';
import { cn } from '../lib/utils';

const SectionHeader = ({ title, subtitle, className, align = 'center' }) => {
  return (
    <div 
      className={cn(
        "mb-16 relative",
        align === 'center' ? 'text-center' : 'text-left',
        className
      )}
      data-aos="fade-up"
    >
      {subtitle && (
        <span className="block text-primary text-sm font-bold tracking-[0.2em] uppercase mb-3">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-6 relative inline-block">
        {title}
        <span className={cn(
          "absolute -bottom-4 h-1 bg-gradient-to-r from-transparent via-primary to-transparent w-24",
          align === 'center' ? 'left-1/2 -translate-x-1/2' : 'left-0'
        )}></span>
      </h2>
    </div>
  );
};

export default SectionHeader;
